import { apiService } from 'core/services/apiService';

export const fetchAllDomains = async (workplaceId: number): Promise<any> => {
	const { ...data } = apiService.responseHandler(
		await apiService.get(`domains/workplace?workplace=${workplaceId}`)
	);

	return data;
};
